$(document).ready(function ($) {
  $("a").click(function() {
    if (this.href.substring(0, 6) === 'mailto')
      return
    if (this.href.substring(0, 10) === 'javascript')
      return
    if (this.href.substring(0, 1) === '#')
      return
    link_host = this.href.split("/")[2];
    document_host = document.location.href.split("/")[2];
    if (document_host === 'shop.reiner-sct.com' &&
	link_host === 'www.reiner-sct.com')
      return
    if (link_host != document_host) {
      window.open(this.href);
      return false;
    }
  });
});
